import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {DataService} from '../../../Services/data.service';
import {StorageService} from '../../../Services/storage.service';
import {BsToastService} from '../../../Services/bs-toast-service';
import {AppConfigService} from '../../../Services/app-config.service';
import {PagerStateService} from '../../../Services/pager-state.service';
import {NgbPaginationConfig} from '@ng-bootstrap/ng-bootstrap';
import {NgbpaginationConfigService} from '../../../Services/ngbpagination-config.service';
import {Project} from '../../../DataModels/project.model';
import {ListPageBase} from '../../list-page-base';

@Component({
  selector: 'app-project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.css'],
  standalone: false
})
export class ProjectListComponent extends ListPageBase implements OnInit {
  vm: any = {
    title: 'Projects',
    list: [] as Project[],
    allRows: [] as Project[],
    company: [],
    selectedCompanyId: '',
    Preferences: [],
    permissions: [],
    listInitiated: false,
    formRoute: '/projects/project-form',
    detailRoute: '/projects/project-detail',
    dashboardRoute: '/projects/project-dashboard',
    statusFilter: '',
    searchTerm: '',
    searchHidden: false,
  };

  tableColumns = [
    {key: 'number', label: 'Number'},
    {key: 'name', label: 'Name'},
    {key: 'entity_name', label: 'Client'},
    {key: 'status', label: 'Status'},
    {key: 'billing_type', label: 'Billing Type'},
    {key: 'due_date', label: 'Due Date'},
    {key: 'percent_complete', label: '% Complete'},
    {key: 'budget_amount', label: 'Budget'},
    {key: 'actions', label: '', sortable: false},
  ];

  onRowAction(event: { action: string; row: any }) {
    if (event.action === 'view') {
      this.onNavigate(event.row.id);
    }
  }

  isLoaded = false;
  pageSize: number;

  constructor(
    private localStorage: StorageService,
    private titleService: Title,
    private tableDataService: DataService,
    private notification: BsToastService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  ngOnInit() {
    this.restorePagerState();
    this.titleService.setTitle(this.vm.title);
    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));
    this.pageSize = this.appConfig.ListPageSize;


    this.loadCompanies();
  }

  loadCompanies() {
    this.tableDataService.getData('company?state=active&pageNumber=0&pageSize=999999').subscribe({
      next: (result: any) => {
        this.vm.company = result.Data || [];
        this.vm.selectedCompanyId = this.vm.Preferences?.defaults?.company_id ?? '';
        this.loadData();
      },
      error: () => {
        this.vm.selectedCompanyId = this.vm.Preferences?.defaults?.company_id ?? '';
        this.loadData();
      },
    });
  }

  onCompanyChange() {
    this.page = 1;
    this.loadData();
  }

  protected fetchPage(): void {
    this.loadData();
  }

  loadData() {
    const companyId = this.vm.selectedCompanyId ?? '';
    let paramString = '?company_id=' + encodeURIComponent(companyId)
      + '&page=' + this.page
      + '&pageSize=' + this.pageSize;
    if (this.vm.statusFilter) {
      paramString += '&status=' + encodeURIComponent(this.vm.statusFilter);
    }

    this.tableDataService.getDataWithParams('project', paramString.replace('?', '')).subscribe({
      next: (result: any) => {
        this.vm.allRows = result.items ?? result.Data ?? [];
        this.applyLocalSearch();
        this.vm.listInitiated = true;
        this.isLoaded = true;
      },
      error: (err) => {
        console.error(err);
        this.notification.showErrorToast('Error loading projects');
      },
    });
  }

  onNavigate(id: string) {
    this.router.navigate([this.vm.detailRoute], {queryParams: {id}}).then();
  }

  onNew() {
    this.router.navigate([this.vm.formRoute]).then();
  }

  onDashboard() {
    this.router.navigate([this.vm.dashboardRoute]).then();
  }

  onStatusFilter(status: string) {
    this.vm.statusFilter = status;
    this.page = 1;
    this.loadData();
  }

  applyLocalSearch() {
    let rows = this.vm.allRows as Project[];
    const term = (this.vm.searchTerm ?? '').toLowerCase().trim();
    if (term) {
      rows = rows.filter(p =>
        (p.name ?? '').toLowerCase().includes(term) ||
        (p.number ?? '').toLowerCase().includes(term) ||
        ((p as any).entity_name ?? '').toLowerCase().includes(term)
      );
    }
    this.vm.list = rows;
    this.totalRecords = rows.length;
  }

  serverSearch(value: any) {
    this.vm.searchTerm = value;
    this.page = 1;
    this.applyLocalSearch();
  }

  clearServerSearch() {
    this.vm.searchTerm = '';
    this.vm.statusFilter = '';
    this.page = 1;
    this.loadData();
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }

  statusBadgeClass(status: string): string {
    switch (status) {
      case 'Active':
        return 'bg-success';
      case 'On Hold':
        return 'bg-warning text-dark';
      case 'Completed':
        return 'bg-primary';
      case 'Cancelled':
        return 'bg-danger';
      default:
        return 'bg-secondary';
    }
  }
}
